import { BrandLockup } from '@shared/ui/icons/BrandMark';

import { chromeCopy, PUBLIC_SITE_ORIGIN } from './copy';

/**
 * A footer ships on every page, carrying the brand mark and the About and
 * Contact entries — those two are mandatory on every public **and** gated
 * surface, which is why an operator console has them at all.
 *
 * Both hrefs leave this host for the public site: the console renders neither
 * page and never imports the sibling's bundle.
 *
 * It carries no prose. A hostname is technical vocabulary, and a rule the
 * interface already enforces on every destructive action does not need
 * announcing to the operator about to meet it.
 */
export function Footer() {
  return (
    <footer
      aria-label={chromeCopy.footer.label}
      className="mt-section-gap border-t border-border bg-bg-sunken pb-8 pt-7"
    >
      <div className="mx-auto w-full max-w-container px-gutter">
        <div className="flex flex-wrap items-center gap-3">
          {/* The full lockup at 0.8 of the top bar's size — the footer row is
              the brand and two links, so it has the width the top bar does not
              and shows the word at every size. Nothing visible here is a
              character; the name is carried in the accessibility tree. */}
          <BrandLockup
            className="flex shrink-0 items-center gap-2 text-ink"
            lockupClassName="h-[2rem] w-[8.288rem] shrink-0"
            label={chromeCopy.brandName}
          />

          <nav aria-label={chromeCopy.footer.linksLabel} className="ms-auto flex flex-wrap gap-x-5 gap-y-2">
            <a
              className="text-sm text-ink-muted no-underline transition-colors duration-fast hover:text-accent-text hover:underline"
              href={`${PUBLIC_SITE_ORIGIN}/about`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {chromeCopy.footer.about}
            </a>
            <a
              className="text-sm text-ink-muted no-underline transition-colors duration-fast hover:text-accent-text hover:underline"
              href={`${PUBLIC_SITE_ORIGIN}/contact`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {chromeCopy.footer.contact}
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
